/**
 * This login's photo, or the business's initial on a gradient when there is
 * none. Fetched with the session token (an <img> can't send it).
 */
import { useEffect, useState } from 'react';
import { fetchPicture } from '../lib/api';

export function usePhoto(photoAt: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!photoAt) {
      setUrl(null);
      return;
    }
    let live = true;
    let made: string | null = null;
    void fetchPicture('/v1/partner/me/photo').then((u) => {
      made = u;
      if (live) setUrl(u);
      else if (u) URL.revokeObjectURL(u);
    });
    return () => {
      live = false;
      if (made) URL.revokeObjectURL(made);
    };
  }, [photoAt]);
  return url;
}

export const initialsOf = (name: string) =>
  name
    .replace(/\(.*?\)/g, '')
    .split(/\s+/)
    .filter((w) => /^[\p{L}\p{N}]/u.test(w))
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join('') || 'L';

export function Photo({
  name,
  photoAt,
  className = 'h-10 w-10 text-sm',
}: {
  name: string;
  photoAt: string | null | undefined;
  className?: string;
}) {
  const url = usePhoto(photoAt);
  return url ? (
    <img
      src={url}
      alt=""
      className={`shrink-0 rounded-full object-cover shadow-lift ${className}`}
    />
  ) : (
    <span
      aria-hidden
      className={`flex shrink-0 items-center justify-center rounded-full font-display font-bold text-white shadow-lift ${className}`}
      style={{ backgroundImage: 'linear-gradient(135deg, #14b8a6, #6d28d9)' }}
    >
      {initialsOf(name)}
    </span>
  );
}
